import { configureStore } from "@reduxjs/toolkit";
import authenticationReducer from "./slices/authenticationSlice";
import commonReducer from "./slices/commonSlice";
import userReducer from "./slices/userSlice";
import notificationsReducer from "./slices/notificationsSlice";
import adminReducer from "./slices/adminSlice";
import adminProductsReducer from "./slices/adminProductsSlice";
import receiptsReducer from "./slices/receiptsSlice";
import adminStoresReducer from "./slices/adminStoreSlice";
import giftsProductsReducer from "./slices/giftsProductsSlice";

export default configureStore({
  reducer: {
    authentication: authenticationReducer,
    common: commonReducer,
    user: userReducer,
    notifications: notificationsReducer,
    admin: adminReducer,
    adminProducts: adminProductsReducer,
    receipts: receiptsReducer,
    adminStores: adminStoresReducer,
    giftsProducts: giftsProductsReducer,
  },
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({ serializableCheck: false }),
});
